export class Comment {
  id: string;
  signupId: string;
  date: string;
  comment: string;
  personId: string;
}
